import { Link } from 'react-router-dom'
import { Button } from '~/shadcn/ui/button/button'

type Props = {
  onLeave(): void
  onRetakeTest(): void
  onContinue(): void
}

export function LowTestScore({ onRetakeTest, onContinue, onLeave }: Props) {
  return (
    <>
      <div className="flex flex-col gap-10">
        <p className="text-[40px] leading-[52px]">Vysoké investičné riziko</p>
        <div className="flex flex-col gap-5">
          <p className="font-medium">
            Na základe vašich odpovedí sa domnievame, že možné riziká spojené s
            investovaním môžu byť pre vás neakceptovateľné alebo by zásadne
            ovplyvnili Vašu životnú úroveň.
          </p>
          <p className="font-medium">
            Preto si myslíme, že momentálne nie ste pripravení investovať svoje
            peniaze. Radi Vám doporučíme vzdelávacie investičné programy, ak nám
            napíšete na{` `}
            <Link
              to="mailto:info@investinslovakia.eu"
              className="text-accent hover:underline">
              info@investinslovakia.eu
            </Link>
            .
          </p>
        </div>

        <p className="text-xl leading-[30px]">
          Ak ste aj napriek tomu presvedčený, že investovať chcete, kliknutím na
          tlačidlo potrvrdzujete, že si uvedomujete možné riziká spojené s
          investíciou a to aj riziká straty celej investovanej čiastky.
        </p>

        <div className="flex flex-col gap-5">
          <Button
            variant="accent"
            className="w-full lg:w-fit"
            size="2xl"
            onClick={onContinue}>
            Potvrdzujem a mám záujem investovať
          </Button>
          <Button
            variant="outline"
            className="w-full lg:w-fit"
            onClick={onLeave}>
            Nemám záujem investovať
          </Button>
        </div>
        <div className="flex flex-col items-start gap-2">
          <p className="font-medium">
            Ak ste počas dotazníka vyplnili informácie omylom, resp. tak, že
            nezodpovedajú skutočnosti, môžete vyplniť dotazník ešte raz.
          </p>
          <Button
            variant="link"
            className="font-medium text-primary p-0 text-accent m-0"
            onClick={(event) => {
              event.preventDefault()
              onRetakeTest()
            }}>
            Vyplniť dotazník znovu
          </Button>
        </div>
      </div>
    </>
  )
}
